module.exports = __webpack_public_path__ + "images/NONE.568125ef908f79cca507ac448bda6383.png";